import React from 'react';
import PropTypes from 'prop-types';
import { Grid, Typography, Button } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';

const useEmptyStateStyles = makeStyles(() => ({
  container: {
    border: (props) => (props.mobile ? null : '1px solid #d9d9d9'),
    borderRadius: (props) => (props.mobile ? null : 10),
    padding: (props) => (props.mobile ? '24px' : '48px 240px'),
    marginTop: (props) => (props.mobile ? 24 : 30),
  },
  typo: {
    fontSize: 16,
    textAlign: 'center',
  },
  button: {
    width: 200,
    height: 40,
  },
}));

const EmptyState = ({ ...props }) => {
  const { idButton, mobile, image, text, buttonText, onClick } = props;
  const classes = useEmptyStateStyles({ mobile });
  return (
    <Grid
      container
      direction="column"
      alignItems="center"
      spacing={3}
      className={classes.container}
    >
      <Grid item>
        <img src={image} />
      </Grid>
      <Grid item>
        <Typography className={classes.typo}>{text}</Typography>
      </Grid>
      <Grid item>
        <Button
          variant="contained"
          color="primary"
          className={classes.button}
          onClick={() => onClick()}
          id={idButton}
        >
          {buttonText}
        </Button>
      </Grid>
    </Grid>
  );
};

EmptyState.propTypes = {
  idButton: PropTypes.string,
  mobile: PropTypes.bool,
  image: PropTypes.element,
  text: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
  buttonText: PropTypes.string,
  onClick: PropTypes.func,
};

export default EmptyState;
